import { Router } from 'react-router-dom';
import { useState, useLayoutEffect } from 'react';

import { browserHistory } from '../history';

type Props = {
  children: React.ReactNode;
};

export default function HistoryRouter({ children }: Props) {
  const [state, setState] = useState({
    action: browserHistory.action,
    location: browserHistory.location,
  });

  useLayoutEffect(() => browserHistory.listen(setState), []);

  return (
    <Router location={state.location} navigationType={state.action} navigator={browserHistory}>
      {children}
    </Router>
  );
}
